import { convertEwsIdToRestId } from 'owa-identifiers';
import { getEmailLink } from './getEmailLinkForNote';
import LinkedEntity, { EMAIL_ENTITY_TYPE } from '../store/schema/LinkedEntity';

export default function getLinkedEmailEntity(
    ewsitemId: string,
    linkedEntitySubtype: string,
    subject: string
): LinkedEntity {
    return {
        Id: convertEwsIdToRestId(ewsitemId),
        WebLink: getEmailLink(ewsitemId),
        EntityType: EMAIL_ENTITY_TYPE,
        EntitySubtype: linkedEntitySubtype,
        DisplayName: subject,
        Preview: {
            RestId: convertEwsIdToRestId(ewsitemId),
        },
    };
}
